import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-configurator-switch-field',
  templateUrl: './switch-field.component.html',
  styleUrls: ['./switch-field.component.scss']
})
export class SwitchFieldComponent {
  @Input() options: any = {};
  @Input() label: String = 'Active';

  constructor() {}
}
